import { AppLayoutHeaderWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Header/HeaderWrapper";
import { AppLayoutWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Wrapper";
import { AppLayoutHeaderDesktop } from "../../Desktop/Header/AppLayoutHeader";
import { AppLayoutInnerWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/InnerWrapper";
import { AppLayoutPageWrapperDesktop } from "@src/appV2/redesign/AppLayout/Desktop/PageWrapper";
import { AllRoutes } from "../../Shared/Navigation/routes/AllRoutes";
import { NavigationMenuItemsTablet } from "./NavigationMenuItems";
import { NavigationMenuItemsWrapperTablet } from "@src/appV2/redesign/AppLayout/Desktop/Tablet/Navigation/MenuItemsWrapper";

export interface AppLayoutTabletProps {
  isAdmin: boolean;
  isWorker: boolean;
  isWorkplace: boolean;
  logoutConfirm: () => void;
  renderStartPage: () => JSX.Element | null;
}

export function AppLayoutTablet(props: AppLayoutTabletProps) {
  const { isAdmin, isWorker, isWorkplace, logoutConfirm, renderStartPage } = props;

  return (
    <AppLayoutWrapperDesktop>
      <AppLayoutHeaderWrapperDesktop>
        <AppLayoutHeaderDesktop logoutConfirm={logoutConfirm} />
      </AppLayoutHeaderWrapperDesktop>
      <AppLayoutInnerWrapperDesktop>
        <NavigationMenuItemsWrapperTablet>
          <NavigationMenuItemsTablet
            isAdmin={isAdmin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
          />
        </NavigationMenuItemsWrapperTablet>
        <AppLayoutPageWrapperDesktop>
          <AllRoutes
            isAdmin={isAdmin}
            isWorker={isWorker}
            isWorkplace={isWorkplace}
            renderStartPage={renderStartPage}
          />
        </AppLayoutPageWrapperDesktop>
      </AppLayoutInnerWrapperDesktop>
    </AppLayoutWrapperDesktop>
  );
}
